import { toast } from 'react-toastify';
export const API_KEY = "72A921EECC93435F8E8349C7D57A78C2"

export const URI = 'https://gradreelsdevapi.azurewebsites.net/'

// export const VIDEO_GEN_URI = 'https://testfuncsrav.azurewebsites.net/'
export const VIDEO_GEN_URI = 'https://func-grvgen-dev-cus-001.azurewebsites.net/'

// previously we shipped static values here for quick dev testing, but they
// must not be treated as real production defaults.  Client/Contact ID should
// always come from the authentication response (query, cookie or admin token).
// The following constants are kept only for reference and can be removed if
// nobody needs them.
// export const ClientId = 109652
// export const ContactId = 154237
//
// export const UserEmail = 'mahesh'
// export const SeasonName = 'Winter'
// export const AdminEmail = 'mpandeti@balfour.com'
// export const ClientName = "Florida International University"

// Gets the items from storage (session first, then local)
// For user authentication data, we only use sessionStorage to prevent cross-session contamination
function getStorageItem(item) {
  if (item === 'clientData') {
    return sessionStorage.getItem(item);
  }
  return sessionStorage.getItem(item) || localStorage.getItem(item)
}

// Sets the items in storage
// For user authentication data, we only use sessionStorage to prevent cross-session contamination
function setStorage(name, data) {
  sessionStorage.setItem(name, data);
  // Only store non-auth data in localStorage
  if (name !== 'clientData') {
    localStorage.setItem(name, data);
  }
}

// Clears the session storage and client data from local storage
export function clearStorage() {
  sessionStorage.clear();
  localStorage.removeItem('clientData');
}

// Remove a specific item from session storage
export function removeItem(key){
  sessionStorage.removeItem(key);
  localStorage.removeItem(key);
}

// Clears stale authentication data when switching between portals
export function clearAuthData() {
  sessionStorage.removeItem('clientData');
  localStorage.removeItem('clientData');
}

// Gets data of client from session storage
export function getClientData() {
  return JSON.parse(getStorageItem('clientData'));
}

// Sets data of client in session storage
export function setClientData(data) {
  setStorage('clientData', JSON.stringify(data));
}

// Gets data of season ID from session storage
export function setSeasonIdForPreEvent(id) {
  setStorage('seasonIdForPreEvent', id);
}

// Sets data of season ID in session storage
export function getSeasonIdForPreEvent() {
  return getStorageItem('seasonIdForPreEvent')
}

// Toaster for success with autoclose with 5 sec
export function toastSuccess(msg) {
  toast.success(msg, {
    autoClose: 5000,
  });
}

// Toaster for error with autoclose with 10 sec
export function toastError(msg) {
  toast.error(msg, {
    autoClose: 10000,
  });
}